export default __webpack_public_path__ + "0a33e3532454f9ecd9d0a4ea0fec38cc.png";